const trueBlue = {
  50: "#e4f1ff",
  100: "#c1dcf9",
  200: "#8fbef0",
  300: "#549ae6",
  400: "#217cde",
  500: "#0068d8",
  600: "#0062cb",
  700: "#0058b7",
  800: "#004fa4",
  900: "#004997",
  A100: "#79b9ff",
  A200: "#3395ff",
  A400: "#007bff",
  A700: "#005fc5",
};

export default trueBlue;
